<template>
  <el-dialog :visible.sync="show" custom-class="error-dialog">
    <p>{{ errorList }}</p>
    <div class="icon"></div>
    <p>考试未通过</p>
    <p>点击重新开始考试（不限次数）</p>
    <div class="btn" @click="confrim">重新考试</div>
    
  </el-dialog>
</template>
<script>
import { fetchAddExam } from "@/api/exam";
export default {
  name: "error-dialog",
  data() {
    return {};
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    errorList: {
      type: String,
      default: ''
    }
  },
  methods: {
    async confrim() {
      let res = await fetchAddExam();
      const { data } = res;
      const { answer } = data;
      const { id } = answer;
      this.$emit("emit");

      this.$router.replace({
        name: "Exam",
        query: {
          id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.error-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 499px;
  height: 339px;
  font-size: 20px;
  border-radius: 10px;
  color: #272222;
  p {
    padding: 5px 0;
    font-weight: 500;
    text-align: center;
  }
  .icon {
    padding-top: 70px;
    background: url(~@/images/disappointment_icon.png) no-repeat;
    background-size: 70px 70px;
    background-position: center;
  }
  .highlight {
    color: #a33b42;
  }
  .btn {
    margin: 0 auto;
    width: 397px;
    height: 60px;
    line-height: 60px;
    margin-top: 10px;
    font-weight: 500;
    text-align: center;
    border: 1px solid #272222;
    cursor: pointer;
  }
}
</style>
